import { createFileRoute } from "@tanstack/react-router";
import { DirectoryPage } from "@/components/directory-page";
import { directoryHead, type DirectoryPageData } from "@/lib/directory-seo";
import { getPublicProviders } from "@/lib/public-content.functions";

export const Route = createFileRoute("/makler")({
  staticData: { sitemap: true },
  loader: async (): Promise<DirectoryPageData> => {
    const { providers, unavailable } = await getPublicProviders({
      data: { type: "immobilienmakler" },
    });
    return { kind: "agent", providers, unavailable };
  },
  head: ({ loaderData }) => directoryHead(loaderData),
  component: Page,
});

function Page() {
  return <DirectoryPage {...Route.useLoaderData()} />;
}
